import React, {Component} from "react";
// import {callGET} from '../../../Utils/ApiUtil';
// import { LinkContainer } from 'react-router-bootstrap';
import {getUserInfo,getWindowIcons,getProfileAuthorities} from '../../../Utils/UserFunctions';
import { withRouter } from "react-router-dom";
import Icons from "../../Icons/Icons";
import WindowIcons from "../../Icons/WindowIcon";
import { isSet } from '../../../Utils/CommonFunctions'

class TopAddShortCut extends Component{
	state ={
		dataJSONPayload:{windowAccess:{}}
	}
  goToWindowList = (param)=>{
	const profileInfo = getProfileAuthorities();
	let userLayouts = [];
	try{
		if(profileInfo!==undefined && profileInfo.data!==undefined && profileInfo!=='' && profileInfo.data!==''){
			profileInfo.data.user_profile_layout.map((item)=>{
				if(param.window_id===item.window_id && item.is_active===true){
					userLayouts.push(item.layout_id);
					this.props.history.push("/layouts/"+param.window_name+"/"+param.window_id+"/add/"+item.layout_id+'/'+Math.floor(Math.random() * 100) + 1);
				}
			})
		}
	}catch(e){

	}
   }
   componentDidMount = ()=>{
	fetch(`/data.json`)
			.then((response) => response.json())
			.then((jsonData) => { this.setState({dataJSONPayload:jsonData}) })
			.catch((error) => console.error('Error fetching JSON:', error));
   }
    
    render(){
		let windowList = [];
		let restrictedMenus = [];
		const {windowAccess} = this.state.dataJSONPayload;
		try{
			if(getUserInfo().data.profile_name===isSet(windowAccess.profile,'')){
				restrictedMenus = isSet(windowAccess.restrictedWindows,[]);
			 }
		}catch(e){

		}
		
		let windowData = this.props.windowData;
		windowData.sort((a, b) => (a.display_priority > b.display_priority) ? 1 : -1)
		windowList = windowData.map((arr,i) => {
			let isAllowAccess = true;
			let svgIcons = isSet(getWindowIcons(),[]);
			let sourceImage = '';
			let htmlCode = '';
			svgIcons.map((item,i)=>{
				if(item.id===arr.window_icon){
					htmlCode = item.html_code;
					sourceImage =  'data:image/svg+xml;base64,'+item.svg_icon;	
				}
			});
	 		// check window access for logged in profile or not..
	 		arr.profiles.map((auth, ai) => {
	 			if(auth.authority_name === 'View'){
	 				isAllowAccess = auth.is_selected;
	 			}
	 		})
			if(isAllowAccess === true || isAllowAccess === 'true'){	
				if(restrictedMenus.indexOf(arr.window_name.toString().toLowerCase())!==-1){
					return false;
				}
				return (
						<a className="col-6 col-md-4 p-0 cursor-pointer"  key={i} onClick={this.goToWindowList.bind(this,arr)} >
						<div className="quick-actions-item secondary_color">
							{/* <img src="/assets/img/task.png" alt="profile" className="hide" /> */} 
							{/*<i className={arr.css_property}></i>*/}
							<div className="avatar-item bg-default rounded-circle">
								{/* <Icons iconType={arr.window_name} /> */}
								{isSet(arr.window_icon,null)!==null?(!arr.system_icon?
									<img src={sourceImage}   width='18' height='18'  />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>

								   :<WindowIcons  size={18} windowIcon={arr.window_icon}/>):
								<Icons iconType={arr.window_name} />
								}
							</div>
							
							<span className="text"> {arr.window_name.toUpperCase()} </span> 
						</div>
						</a>
					);
			}
		});
		return (
			<div className="dropdown-menu quick-actions quick-actions-info animated fadeIn" style={{minWidth:'30rem', borderRadius:'10px'}}>
				 
					<div className="quick-actions-items">
						<div className="row m-0">
							{windowList}
						</div>
					</div>
				 
			 
				 
			</div>
		);
    }
}

export default withRouter(TopAddShortCut);